import * as React from 'react'

import ClientOnly from 'app/components/ClientOnly'
import LazyLoadAnimation from 'app/helpers/LazyLoadAnimation'

interface Props {
  mediaUrl: string
  altText?: string
  animationLoop?: boolean
  objectFit?: React.CSSProperties['objectFit']
  width?: React.CSSProperties['width']
  height?: React.CSSProperties['height']
}

const isMediaAnimation = (mediaUrl: string) => mediaUrl?.endsWith('.json')

const LazyLoadMedia: React.FC<Props> = ({
  mediaUrl,
  altText,
  animationLoop = true,
  objectFit = 'contain',
  width = '100%',
  height = '100%',
}) => {
  return isMediaAnimation(mediaUrl) ? (
    <ClientOnly>
      <LazyLoadAnimation mediaUrl={mediaUrl} loop={animationLoop} />
    </ClientOnly>
  ) : (
    <img loading="lazy" src={mediaUrl} alt={altText} width={width} height={height} style={{ objectFit }} />
  )
}

export default LazyLoadMedia
